import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import MainScreen from './Components/MainScreen';
import WithNav from './Components/Navbar/With/WithNav';
import WithoutNav from './Components/Navbar/With/WithoutNav';
import Login from './Components/Login/Login';
import Dashboard from './Components/Dashboard/Dashboard';
import Agreement from './Components/CallwithUs/SubCallwithUs/Agreement';
import BrandingPage from './Components/Branding/BrandingPage';
import Support from './Components/Support/Support';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<WithoutNav />}>
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/agreement' element={<Agreement />} />
          <Route path='/branding' element={<BrandingPage />} />
        </Route>
        <Route element={<WithNav />}>
          <Route path='/' element={<MainScreen />} />
          <Route path='/login' element={<Login />} />
          <Route path='/support' element={<Support />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
